<template>
	<div class="ordering" v-loading.fullscreen.lock="loading">
		<div class="heading">菜品管理</div>
		<div class="content-view">
			<div class="button-view" style="display: flex; justify-content: space-between;">
				<div class="search-view" style="display: flex; align-items: center;">
					<span style="margin-right: 10px;">菜品目录：</span>
					<el-select v-model="searchCategory" placeholder="请选择菜品类目" style="width: 200px; margin-left: 0;" @change="(category) => searchDishes(category)">
						<el-option
							v-for="item in category"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>

				<router-link :to="{name:'upload'}">
				<el-button type="success" size="medium">添加菜品</el-button>
				</router-link>
			</div>
			<div v-if="nodatas">
				<!-- 表头 -->
				<div class="tab-list">
					<span v-for="(item,index) in tablist" :key="index">{{item}}</span>
				</div>
				<!-- 表格 -->
				<div class="tab-table" v-for="(goods_item,index) in tabcont" :key="index">
				<div>{{goods_item.time}}</div>
				<div>{{goods_item.category}}</div>
				<div>{{goods_item.name}}</div>
				<div>
					<el-image class="elimg"
					:src="goods_item.image[0].url"
					fit="cover"
					:lazy="true"
					:preview-src-list="[goods_item.image[0].url]">
					</el-image>
				</div>
				<div>{{goods_item.unitprice}}</div>
				<div>{{goods_item.dishSort}}</div>
			  <div>
				  <el-button size="small" @click="edIt(goods_item)" :disabled="goods_item.onsale ? false : true ">编辑</el-button>
				  <el-button v-if="goods_item.onsale" type="danger" size="small" @click="shelf(goods_item._id,index,goods_item.cid)" :loading="index == shelfload ? true : false" :disabled="index == shelfload ? true : false">下架</el-button>
				  <el-button v-else type="success" size="small" @click="putOnSale(goods_item._id,index,goods_item.cid)" :loading="index == putOnLoad ? true : false" :disabled="index == putOnLoad ? true : false">上架</el-button>
				  <el-button type="danger" size="small" @click="deleteDish(goods_item._id,index,goods_item.cid)">删除</el-button>
			  </div>
			  </div>
				<!-- 分页 -->
				<!-- <el-pagination
				  background
				  layout="prev, pager, next"
				  :hide-on-single-page="true"
				  :total="total"
				  @current-change="currentchange"
				  >
				</el-pagination> -->
			</div>
			<!-- 没有数据 -->
			<div class="nodatas" v-if="!nodatas">还没有菜品数据</div>
		</div>
		<div style="height: 120px;"></div>
	</div>
</template>

<script>
export default{
		data() {
		return {
			loading: true,
			nodatas:true,
			shelfload:-1,//下架loading
			putOnLoad:-1,//上架loading
			tablist: ['创建时间','类目','菜品名称','菜品图片','价格(元)','排序','操作'],
			tabcont:[],
			currentnum:1,//当前页数
			total:0,//总条数
			pagenum:0,
			category: [], // 菜品类目
			searchCategory: '', // 搜索的类目
			searchLoading: false // 搜索按钮加载状态
		}
	},
	methods:{
		// 分页
		currentchange(e){
			console.log('当前选中的菜品类目:', this.searchCategory)
			this.pagenum = e - 1
			this.obtaindishes()
		},
		async searchDishes() {
			this.obtaindishes()
		},
		// 获取菜品
		async obtaindishes(){
			try{
				let url = this.Urls.m().obtaindishes + '?page=' + this.pagenum;
				console.log('参数111111111:', this.searchCategory);
				url += '&category=' + this.searchCategory;
				let res = await new this.Request(url).modeget()
				this.nodatas = res.data.data.tatal == 0  ? false : true
				this.tabcont = res.data.data.result
				this.total = res.data.data.tatal
				this.loading = false
			}catch(e){
				this.loading = false
				new this.mytitle(this.$message,'error','服务器发生错误,请重试').funtitle()
			}
		},
		// 编辑修改
		edIt(item){
			this.$router.push({name:'upload',params:{item}});
		},
		// 下架
		async shelf(id,index,value){
			this.shelfload = index
			let obj = this.$qs.stringify({id,value})
			try{
				await new this.Request(this.Urls.m().fromsale + '?' + obj).modeget()
				this.$set(this.tabcont[index],'onsale',false)
				this.shelfload = -1
			}catch(e){
				this.shelfload = -1
				new this.mytitle(this.$message,'error','下架失败，重试').funtitle()
			}
		},
		// 上架
		async putOnSale(id,index,cid){
			this.putOnLoad = index
			let obj = this.$qs.stringify({id,cid})
			try{
				await new this.Request(this.Urls.m().putOnSale + '?' + obj).modeget()
				this.$set(this.tabcont[index],'onsale',true)
				this.putOnLoad = -1
				new this.mytitle(this.$message,'success','上架成功').funtitle()
			}catch(e){
				this.putOnLoad = -1
				new this.mytitle(this.$message,'error','上架失败').funtitle()
			}
		},
		// 删除
		async deleteDish(id,index,cid){
			try{
				await this.$confirm('确定要删除该菜品吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				let obj = this.$qs.stringify({id,cid})
				await new this.Request(this.Urls.m().deleteDish + '?' + obj).modeget()
				this.tabcont.splice(index, 1)
				if(this.tabcont.length === 0) {
					this.nodatas = false
				}
				new this.mytitle(this.$message,'success','删除成功').funtitle()
			}catch(e){
				if(e !== 'cancel') {
					new this.mytitle(this.$message,'error','删除失败').funtitle()
				}
			}
		},
		// 获取菜品类目
		async obtaincate() {
			try {
				let res = await new this.Request(this.Urls.m().obtaincate).modeget();
				console.log('获取到的菜品类目数据:', res.data.data.result);
				this.category = res.data.data.result;
				// 设置默认值为第一个类目
				if(this.category.length > 0) {
					console.log('设置默认菜品类目:', this.category[0].value);
					this.searchCategory = this.category[0].value;
					this.searchDishes();
				} else {
					console.warn('没有获取到菜品类目数据');
				}
			} catch(e) {
				console.error('获取菜品类目失败:', e);
				new this.mytitle(this.$message,'error','获取类目失败').funtitle();
			}
		},
		// 搜索菜品
		async searchDishes(cid) {
			this.searchLoading = true;
			this.pagenum = 0;
			try {
				await this.obtaindishes(cid);
			} finally {
				this.searchLoading = false;
			}
		}
	},
	created() {
		this.obtaincate();
		//this.obtaindishes();
	},
}
</script>

<style scoped="scoped">
@import url("../../../style/pubiss.css");
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #00be06;
	color: #fff;
}
/* 分页 */
.el-pagination {
	text-align: center;
	margin: 30px 0;
}
@media (max-width: 768px) {
.ordering {
  	width: 100%;
}
.tab-list {
	width: 550px;
}
.tab-table {
	width: 550px;
}
.el-button--default{
	margin-left: 10px;
}
}
</style>
